import { BASE_STORE_URL } from '@/request/config';
import request from '@/request/tsRequest';
import { ISku } from '@/components/ProductCard/typings';
import { ISuggestionItem } from '@/components/Search/components/Suggestions';
import { IResponseFilters, IRequestFilters } from '@/pages/search/components/PCFilter/typings';
import { EnumRankValue } from './components/RankDropdown/typings';
import { EnumSearchBiz } from '@/pages/search/constants';

/** 获取filter */
export function getFilters(search: string) {
  return request<{ filterInfo: IResponseFilters }>({
    url: BASE_STORE_URL + '/search/filterSuggest',
    params: {
      search,
    },
    serializer: true,
  });
}

/** 获取默认推荐商品 */
export function getDefaultRecommends() {
  return request<IDataWithPageInfo<ISku<ISearchResponses>[]>>({
    url: BASE_STORE_URL + '/search/defaultRecommend',
  });
}

interface IPageInfo {
  page: number;
  prePage: number;
  totalCount: number;
  totalPage: number;
}

type IDataWithPageInfo<T> = {
  records: T;
  page: IPageInfo;
  // 当前search字段
  search: string;
  // OpenSearch相关
  requestId: string;
  // OpenSearch相关
  opsRequestMisc: string;
};

/** 获取下拉框查询 */
export function getSuggest(search: string, biz: `${EnumSearchBiz}`) {
  return request<IDataWithPageInfo<ISuggestionItem[]>>({
    url: BASE_STORE_URL + '/search/suggest',
    params: {
      search,
      biz,
    },
    serializer: true,
  });
}

export interface ISearchParams {
  discountMark?: boolean;
  search: string;
  sort: EnumRankValue;
  page: {
    perPage: number;
    page: number;
  };
  filterInfo?: IRequestFilters;
}

// 埋点相关
type ISearchResponses = {
  // opensearch请求相关
  opsRequestMisc: string;
  // opensearch请求相关
  requestId: string;
  // opensearch请求相关
  documentId: number;
};

export type ISkuInSearch = ISku<ISearchResponses>;

/** 获取搜索结果 */
export function getSearch(data: ISearchParams) {
  return request<IDataWithPageInfo<ISku<ISearchResponses>[]>>({
    url: BASE_STORE_URL + '/search/search',
    method: 'POST',
    data,
  });
}
